/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "G-MKPFG3H17C",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Abhishek",
  logo_name: "<Abhishek />",
  nickname: "Abhi",
  full_name: "Abhishek Rajput",
  subTitle: "I am a Full Stack Developer. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/14APVkjrhduIcOpEltJIqTVXcT1wN5btX/view?usp=sharing",
  mail: "mailto:Abhishekgr154@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/rajput999",
  linkedin: "https://www.linkedin.com/in/abhishek-rajput-ak/",
  gmail: "Abhishekgr154@gmail.com",
  gitlab: " ",
  facebook: " ",
  twitter: " ",
  instagram: " ",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using HTML,CSS ,Javascript and ReactJS",
        "⚡ Backend development using NodeJS and ExpressJS",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        // {
        //   skillName: "C#",
        //   fontAwesomeClassname: "simple-icons:csharp",
        //   style: {
        //     backgroundColor: "transparent",
        //     color: "#3776AB",
        //   },
        // },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        // {
        //   skillName: "MySQL",
        //   fontAwesomeClassname: "simple-icons:mysql",
        //   style: {
        //     color: "#4479A1",
        //   },
        // },

        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "IIT Kharagpur",
      subtitle: "B.tech dual in Mechanical Engineering",
      logo_path: "kgp.png",
      alt_name: "KGP",
      duration: "2021 - 2026",
      descriptions: [
        "⚡ Pursuing a Dual Degree M.Tech in Mechanical Engineering at IIT Kharagpur, a prestigious institution known for its rigorous academic curriculum and cutting-edge research opportunities",
        "⚡ Benefiting from exposure to interdisciplinary projects and collaboration with top-tier faculty and peers, fostering innovation and technical proficiency",
        "⚡ Gaining in-depth knowledge and practical experience in core mechanical engineering subjects, equipping me with a solid foundation to tackle complex engineering challenges ",
      ],
      website_link: "https://www.iitkgp.ac.in/",
    },
    {
      title: "Kanha Makhan Public School, Vrindavan",
      subtitle: "12-th CBSE",
      logo_path: "kmps.png",
      alt_name: "KMPS",
      duration: "2020 - 2021",
      descriptions: [
        "⚡ Attained a solid foundation in mathematics and science during the 12th class, building a fundamental understanding of key concepts.",
        "⚡ Developed strong analytical and problem-solving skills through coursework in math and science subjects.",
        "⚡ Well-prepared for higher education in fields such as engineering, computer science, physics, or related disciplines with a background in math and science. ",
      ],
      website_link: "https://www.kmpsmathura.org/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Supervised Machine Learning",
      subtitle: "Coursera",
      logo_path: "coursera.png",
      certificate_link:
        "https://coursera.org/share/c87de4265a4dad56b620349fc9bac246",
      alt_name: "Coursera",
      color_code: "#A9F5A9",
    },
    {
      title: "Problem Solving (Intermediate) Certificate",
      subtitle: "HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "",
      alt_name: "AWS",
      color_code: "#D8CEF6",
    },
    {
      title: "CSS (Basic) Certificate",
      subtitle: "HackerRank",
      logo_path: "hackerrank.png",
      certificate_link: "",
      alt_name: "AWS",
      color_code: "#F4FA58",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    "I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer Internship",
          company: "Qurve AI",
          company_url: "https://qurve.ai/",
          logo_path: "qurve.png",
          duration: "Dec 2024 - Present",
          location: "Work From Home",
          description:
            "◦ Developed a full-stack website using the MERN stack, enhancing user experience and responsive desig ◦ Built chatbot for websites, enabling text/voice interactions, spoken responses, and visual content navigation ◦ Implemented an system to extract URLs, scrape data, and facilitate similarity-based search for deeper insights ◦ Used processed data to train LLMs, creating an efficient response bank for intelligent customer interactions.",
          color: "#ee3c26",
        },
        {
          title: "Software Developer Internship",
          company: "Vani AI",
          company_url: "https://vani.coach/",
          logo_path: "vani.png",
          duration: "May 2024 - Nov-2024",
          location: "Work From Home",
          description:
            "• Developed and trained AI models using Deep Learning and Natural Language Processing to improve personalized communication • Created multiple webpages using React.js and successfully integrated APIs to improve functionality and enhance user experience • Automated data cleaning and processing using libraries such as Assembly AI and SpellChecker and other enhancing speed by about 90% • Engineered advanced AI-driven solutions for personalized learning experiences using LLM models like Google BERT, GPT-2, and others.",
          color: "#ee3c26",
        },
        {
          title: " Subect Matter Expert- Computer Science",
          company: "Chegg Inc",
          company_url: "https://www.cheggindia.com/",
          logo_path: "chegg.png",
          duration: "March 2023 - Dec-2023",
          location: "Work From Home",
          description:
            "I provide academic assistance to students by answering questions related to various topics. ◦ I strive to deliver solutions that are accurate, concise, helping students to achieve their academic goals ◦ promptly and professionally answering students’ questions through effective communication is essential for expert",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Tech-Team Head",
          company: "Kshitij Tech-fest, IIT Kharagpur",
          company_url: " ",
          logo_path: "ktj.png",
          duration: "April 2023 - Jan-2024",
          location: "IIT KHARAGPUR",
          description:
            "• Successfully executed a extensive Web-a-thon event in close collaboration with MongoDB, engaging over 500 active student participants • Led the development team in creating a website for Kshitij, IIT Kharagpur, utilizing the MERN stack to deliver dynamic online platform • Successfully led tech team to achieve over 400,000 clicks on website in just 2 months through effective teamwork and strategic planning",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of variety of latest technology tools. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Abhishek.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

const projects = {
  data: [
    {
      name: "Travel Website for Family Bussiness",
      url: "https://github.com/rajput999/Travel-website",
      description:
        "Created a React-based travel website for our family business, featuring an intuitive interface that effectively showcases tour packages and booking options",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Node.js",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Express.js",
          iconifyClass: "logos-express",
        },
      ],
    },
    {
      name: "Token-Management-Dashboard (Web3)",
      url: "https://github.com/rajput999/Token-Management-Dashboard",
      description:
        "allows users to manage and monitor their cryptocurrency portfolio. Users can add tokens, view balances, check token allowances, and perform token operations like transfers and approvals",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      name: "Idea2Market-AI",
      url: "https://github.com/rajput999/Idea2Market-AI",
      description:
        "Generates logos and offers detailed information about products in response to user prompts • Used React for frontend, integrating OpenAI APIs for text processing and DALL-E APIs for generating images",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "OpenAI",
          iconifyClass: "logos-openai",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
